import { LoyaltyClusterTypeService } from 'app/services/loyalty/loyalty-cluster-type.service';
import { Permission } from './../../../models/permission.model';
import { PermsService } from './../../../services/utils/perms.service';
import { Observable } from 'rxjs';
import { Component, OnInit } from '@angular/core';
import { Cluster } from '../../../models/loyalty-cluster.model';
import { Router } from '@angular/router';
import { LoyaltyClusterService } from '../../../services/loyalty/loyalty-cluster.service';
import { TranslateService } from '@ngx-translate/core';
import { KontableComponent } from '../../../modules/UIKit/components/kontable/kontable.component';

@Component({
  selector: 'app-loyalty-cluster',
  templateUrl: './loyalty-cluster.component.html',
  styleUrls: ['./loyalty-cluster.component.css']
})
export class LoyaltyClusterComponent implements OnInit {

  clusters: Array<Cluster>;
  serverPagination = KontableComponent.ServerPagination;
  newDataAvailable = false;
  listStates: Array<{value: string, label: string}>;
  show = {
    datatable: false
  }
  customFilter = KontableComponent.CustomFilter;
  selectFilter = KontableComponent.SelectFilter;

  // Mostra tasti di edit, delete e recover
  clusterPermission: Permission;

  listClusterType: Array<{ label: string, value: number}> = [{value: null, label: '' }];

  constructor(
    private translate: TranslateService,
    public clusterService: LoyaltyClusterService,
    private router: Router,
    private srvPermission: PermsService,
    private clusterTypeService: LoyaltyClusterTypeService
  ) { }

  ngOnInit() {


    const TRANSLATIONS =   this.translate.get([
      'common.coupon_valid',
      'common.coupon_deleted'
    ]);

    const PERMISSIONS = this.srvPermission.getPermission({ms_base: 'koncentro-loyalty', operation: 'reason'});

    const ClusterTypes: Observable<any> = this.clusterTypeService.getAll();;

    Observable.zip(
      TRANSLATIONS,
      PERMISSIONS,
      ClusterTypes
    ).subscribe(([resTranslation, resPermissions, resClusterType]) => {

    this.clusterPermission = resPermissions;

    this.listStates = [];
    this.listStates.push({ label: '', value: null });
    this.listStates.push({ label: resTranslation['common.coupon_valid'], value: '0' });
    this.listStates.push({ label: resTranslation['common.coupon_deleted'], value: '1' });

    this.show.datatable = true;

    for (const clusterType of resClusterType.data) {
      console.log('*****', clusterType);
      this.listClusterType.push({value: clusterType.code, label: clusterType.code + " - " + clusterType.description });
    }

  });

  }

  addNew(event: any) {
    this.router.navigate(['/loyalty/cluster/form/']);
  }

  edit(cluster: Cluster) {
    this.router.navigate(['/loyalty/cluster/form/' + cluster.id]);
  }

  remove(cluster) {
    this.clusterService.remove(cluster.id).subscribe((res ) => {
      this.newDataAvailable = true;
    });
  }
  recover(cluster){
    this.clusterService.recover(cluster).subscribe((res) => {
      this.newDataAvailable = true;
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/views/loyalty/loyalty-cluster/loyalty-cluster.component.ts